module.exports = __webpack_public_path__ + "static/media/contact-page-mail.d9cd5b05.svg";